<template>
  <div class="adminSendMessageView-all-box form-info-box">
    <card>
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        class="demo-ruleForm clearfix"
        label-position="left"
      >
        <el-form-item prop="title" class="line">
          <div class="title-name">{{ $t('queryForm.title') }}</div>
          <el-input v-model="ruleForm.title" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" />
        </el-form-item>

        <el-form-item prop="content" class="line">
          <div class="title-name">{{ $t('queryForm.content') }}</div>
          <!-- <el-input v-model="ruleForm.content" resize="none" type="textarea" rows="10" :placeholder="$t('queryForm.pleaseEnter')" :disabled="isdis == 1" /> -->
          <tinymce-editor 
            v-model="ruleForm.content"
            :init="editorInit"
            :disabled="isdis == 1"
            ></tinymce-editor>
        </el-form-item>

        <el-form-item class="line btn-box input-form-btn-list">
          <!-- <el-button type="primary" plain @click="cancel">Cancel</el-button>
          <el-button type="primary" v-if="isdis !== 1"  round @click="submissionBtn('ruleForm')">Send</el-button> -->
          <cus-btn type="cancel" @click="cancel()"></cus-btn>
          <cus-btn type="send" v-if="isdis !== 1" @click="submissionBtn('ruleForm')"></cus-btn>
        </el-form-item>
      </el-form>
    </card>
  </div>
</template>

<script>
import { sysNoticeSendNotice, sysNoticeSelectDetail } from '../../api/adminManagement'
import Editor from '@tinymce/tinymce-vue';

export default {
  name: 'AdminSendMessageView',
  components: {
    'tinymce-editor': Editor
  },
  data() {
    return {
      ruleForm: {
        title: '',
        content: ''
      },
      isdis: '',
      // rules: {
      //   input1: [{ required: true, message: '请输入', trigger: 'blur' }],
      //   input2: [{ required: true, message: '请输入', trigger: 'blur' }],
      // },
      editorInit:{
        width:'100%',
        height:'500',
        language: this.$store.state.app.language == "zh"? "zh_CN":"en",
        menubar: false,
        font_formats:
        "宋体=宋体;黑体=黑体;仿宋=仿宋;楷体=楷体;隶书=隶书;幼圆=幼圆;Arial=arial,helvetica,sans-serif;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Tahoma=tahoma,arial,helvetica,sans-serif;Times New Roman=times new roman,times;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings,zapf dingbats",
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table directionality emoticons template paste fullpage"
      ],
      toolbar1:
        "insertfile undo redo | styleselect fontselect| table | bold italic | " +
        "alignleft aligncenter alignright alignjustify | " +
        "bullist numlist outdent indent | link customerImageUploader | " +
        "preview | forecolor backcolor  code fullscreen" 
      }
    }
  },
  computed: {
    // lang() {
    //   return this.$store.state.app.language
    // },
    rules(){
      return {
        title: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
        content: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'blur' }],
      }
    }
  },
  watch: {
    // lang() {

    // }
  },
  mounted() {
    if (this.$route.params.id) {
      this.isdis = this.$route.params.type
      this.subUserdetail()
    }

  },
  methods: {
    /**
    * 返回上一页
    */
    cancel() {
      this.$router.push({
        name: 'adminNoticeListView'
      })
    },

    // 账户信息查看
    subUserdetail() {
      const param = {
        id: this.$route.params.id // id
      }
      sysNoticeSelectDetail(param)
        .then(response => {
          if (response.code === 200) {
            this.ruleForm.title = response.data.title
            this.ruleForm.content = response.data.content

          }
        })
    },

    // 账号提交
    submissionBtn(formName) {
      // console.log(this.$store.state.user.userinfo.userId)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const param = {
            title: this.ruleForm.title,
            content: this.ruleForm.content,
            // userIds: this.$store.state.user.userinfo.userId,
            type: '1'
          }
          sysNoticeSendNotice(param)
            .then(response => {
              if (response.code === 200) {
                this.$message({
                  message: response.message,
                  type: 'success'
                })
                this.$router.push({
                  name: 'adminNoticeListView'
                })
              }
            })
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">

</style>
